import React, { useMemo } from 'react';

export function SelectQuestion({ question, value, onChange, allAnswers = {} }) {
  // Resolve options - support both static arrays and dynamic functions
  const options = useMemo(() => {
    if (typeof question.options === 'function') {
      return question.options(allAnswers);
    }
    return question.options;
  }, [question.options, allAnswers]);

  return (
    <select
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition text-gray-700"
    >
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  );
}
